module.exports = __webpack_public_path__ + "static/media/img-116.1fa31995.jpg";